// extracted by mini-css-extract-plugin
export var megalist = "index-module--megalist--c4137";
export var megamenu = "index-module--megamenu--4f63f";
export var navdesktop = "index-module--navdesktop--f8dd2";